import { useMutation } from '@tanstack/react-query';

import InclusionsService from '~/services/InclusionsService';
import PackagesService from '~/services/PackagesService';

import type { PackageInclusionMutationPayload } from '../inclusions/packageInclusionMutationUtils';

interface SaveOfferPackageParams {
  offerId: string;
  packageData: Record<string, unknown>;
  packageId: string;
  packageInclusions: Array<PackageInclusionMutationPayload>;
}

export function useSaveOfferPackage() {
  return useMutation({
    mutationFn: async ({ offerId, packageData, packageId, packageInclusions }: SaveOfferPackageParams) => {
      // Matches legacy PackageForm: inclusion and package saves are separate calls, so this is not atomic.
      await InclusionsService.updatePackageInclusion({
        package_inclusions: packageInclusions,
      });

      return PackagesService.updatePackage(packageData, offerId, packageId);
    },
  });
}
